import { FC } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import styled from '@ui/styles/styled';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import './slider.css';

import Typography from '@ui/Typography';

import IconButton from '@material-ui/core/IconButton';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

import {
    sliderContentStyle,
    sliderAssetStyle,
    sliderAssetBigStyle,
    sliderBodyItemsWrapperStyle,
    sliderTitleStyle,
    sliderBodyStyle,
    sliderAssetStyleFullHeight,
    previousButtonStyle,
    nextButtonStyle,
} from './styles';
import ISliderProperties from './types';

const StyledPreviousButton = styled(IconButton)(previousButtonStyle);
const StyledNextButton = styled(IconButton)(nextButtonStyle);

const Slider: FC<ISliderProperties> = ({ description, sources }) => {
    const params = {
        slidesPerView : 1,
        effect        : 'fade',
        loop          : true,
        pagination    : {
            el             : '.swiper-pagination',
            clickable      : true,
            dynamicBullets : true,
        },
        navigation: {
            nextEl : '.swiper-button-next',
            prevEl : '.swiper-button-prev',
        },
        renderPrevButton : () => <StyledPreviousButton className="swiper-button-prev"><PlayCircleFilledIcon /></StyledPreviousButton>,
        renderNextButton : () => <StyledNextButton className="swiper-button-next"><PlayCircleFilledIcon /></StyledNextButton>,
    };

    return (
        <div style={sliderContentStyle}>
            {sources && (
                <Swiper {...params}>
                    {sources.map((source) => (
                        <div key={source}>
                            <div style={description ? sliderAssetStyle : (window.matchMedia('(max-width: 600px)').matches ? sliderAssetStyleFullHeight : sliderAssetBigStyle)}>
                                <img style={description ? sliderAssetStyle : (window.matchMedia('(max-width: 600px)').matches ? sliderAssetStyleFullHeight : sliderAssetBigStyle)} key={source} alt="slider" src={source} />
                            </div>
                        </div>
                    ))}
                </Swiper>
            )}

            {description && (
                <div style={sliderBodyItemsWrapperStyle}>
                    {description?.titleLabelId && (
                        <Typography variant="h6" style={sliderTitleStyle}>
                            <FormattedMessage id={description.titleLabelId} />
                        </Typography>
                    )}
                    {description?.contentLabelId && (
                        <Typography variant="body2" style={sliderBodyStyle}>
                            <FormattedHTMLMessage id={description.contentLabelId} />
                        </Typography>
                    )}
                </div>
            )}
        </div>
    );
};

export default Slider;
